import { TIK_TOK_SERVICE_ID } from '../../config/analytics';

const createTTQObject = () => {
  if (!window.ttq) {
    /* eslint-disable */
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
    }(window, document, 'ttq');
    /* eslint-enable */
  }
};

export const initializeTikTokPixel = () => {
  createTTQObject();
  try {
    window.ttq.load(TIK_TOK_SERVICE_ID);
    window.ttq.page();
  } catch (error) {
    window.bugsnag.notify(error);
  }
};

export const trackPageView = () => {
  if (window.ttq) {
    window.ttq.track('Browse');
  }
};

export const trackRegistration = () => {
  if (window.ttq) {
    window.ttq.track('Registration');
  }
};

export const trackAddPackageToCart = ({ packageSku, packagePrice, packageName }) => {
  if (window.ttq) {
    window.ttq.track(
      'AddToCart',
      {
        content_category: 'package',
        content_id: packageSku,
        content_name: packageName,
        value: packagePrice,
        currency: 'USD'
      });
  }
};

export const trackPackagePurchase = ({ orderTotal }) => {
  if (window.ttq) {
    window.ttq.track(
      'Purchase',
      { value: orderTotal, currency: 'USD' }
    );
  }
};

export const trackMerchPurchase = ({ displayedInfo }) => {
  if (window.ttq) {
    const {
      displayedShipping,
      displayedTax,
      displayedTotal
    } = displayedInfo;

    // displayed total less shipping and handling
    // should be the total after discounts have been applied
    const totalLessDiscounts = parseFloat(displayedTotal) -
      parseFloat(displayedTax) - parseFloat(displayedShipping);

    window.ttq.track('Checkout', {
      value: totalLessDiscounts.toFixed(2),
      currency: 'USD',
      content_category: 'product'
    });
  }
};
